<template>
  <div>
    <!--已报名-->
    <div v-if="isSign">
      <!--表格-->
      <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%;"
      >
        <el-table-column
            fixed
            prop="num"
            label="序号"
            width="80">
        </el-table-column>
        <el-table-column
            prop="content"
            label="上传内容"
            width="218">
        </el-table-column>
        <el-table-column
            prop="require"
            label="是否需要上传"
            width="510">
        </el-table-column>
        <el-table-column
            label="手动上传"
            width="110">
          <el-upload class="upload" slot-scope="scope"
                     :show-file-list="false"
                     action="https://jybks.chuxingshi.top/api/index/upload"
                     :on-success="(res)=>upLoad(res,scope.$index,scope.row)"
          >
            <div class="pointer bold" style="color: #337ab7">点击上传</div>
          </el-upload>
        </el-table-column>
        <el-table-column
            label="查看"
            width="110">
          <div class="pointer bold" style="color: #337ab7" slot-scope="img" @click="showImg(img.$index,img.row)">点击查看</div>
        </el-table-column>
        <el-table-column
            prop="isUP"
            label="是否已上传"
            width="100">
        </el-table-column>
        <el-table-column
            prop="conmp"
            label="审核通过"
            width="90">
        </el-table-column>

      </el-table>
      <!--图片预览-->
      <el-dialog :visible.sync="showDialog">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
    </div>
    <!--未报名-->
    <div v-else class="difcc" style="height: 65vh;">
      <el-result icon="info" title="尚未报名" subTitle="点击前往报名">
        <div slot="extra" class="difcc">
          <el-button type="primary" @click="goSign()">去报名</el-button>
        </div>
      </el-result>
    </div>
  </div>
</template>

<script>
export default {
  name: 'updateInfo',
  methods: {
    goSign() { //去报名
      this.$router.push('/infoCenter/sign').catch(err => err)
    },
    //预览图片
    showImg(index,row) {
      //判断有无图片
      if(row.url) {
        this.dialogImageUrl = this.$store.state.url + row.url
        this.showDialog = true
      }else {
        this.$alert('暂未上传',{type: 'error'})
      }
    },
    //上传图片
    upLoad(res,index,row) {
      let image = res.data //图片上传成功后的链接
      this.$axios("POST","/index/bmImage",{
        type: (index*1)+1,
        image: image,
        baoming_id: this.baoming_id
      },'上传中').then(res => {
        if(res.code===1) {
          this.getUpload()
          this.$alert('上传成功',{type: 'success'})
        }else {
          this.$alert(res.msg,{type: 'error'})
        }
      })
    },
    //获取用户信息
    getUserInfo() {
      this.$axios("POST","/user/info",{})
      .then(res => {
        if(res.code===1) {
          if(res.data.baoming_id) {
            this.baoming_id = res.data.baoming_id
            this.getUpload();
          }else {
            this.isSign = false
          }
        }
      })
    },
    //获取上传信息
    getUpload() {
      this.$axios("POST","/index/bmImageList",{
        baoming_id: this.baoming_id,
      }).then(res => {
        if(res.code===1) {
          this.isSign = true
          for(let item of res.data) {
            let index = item.type-1
            let data = this.tableData[index]
            data.url = item.image
            if(item.is_file==1) data.isUP = '已上传'
            if(item.audit==0) {
              data.conmp = '正在审核'
            }else if(item.audit==1) {
              data.conmp = '审核成功'
            }else if(item.audit==2) {
              data.conmp = '审核拒绝'
            }
          }
          this.$forceUpdate()
        }
      })
    },
  },
  data() {
    return {
      isSign: false,//是否报名
      tableData: [{
        num: '1-1',//序号
        content: '考生身份证头像面图片*',//上传内容
        require: '必须上传',//是否需要上传
        isUP: '未上传',//是否已上传
        conmp: '否',//审核通过
        url: '',//查看链接
      }, {
        num: '1-2',
        content: '考生身份证国徽面图片*',
        require: '必须上传',
        isUP: '未上传',
        conmp: '否',
        url: '',
      }, {
        num: '2',
        content: '考生近期免冠照片*',
        require: '必须上传，先上传证件图片后再上传照片',
        isUP: '未上传',
        conmp: '否',
        url: '',
      }, {
        num: '3',
        content: '济南市居住证图片',
        require: '户籍不是济南市的考生需要上传',
        isUP: '未上传',
        conmp: '否',
        url: '',
      }, {
        num: '4',
        content: '济南市社保缴纳证明',
        require: '第一次申请济南市居住证，居住证正在办理中需上传',
        isUP: '未上传',
        conmp: '否',
        url: '',
      }, {
        num: '5',
        content: '高中毕业证明图片',
        require: '未满18岁考生需上传高中同等学历毕业证书图片',
        isUP: '未上传',
        conmp: '否',
        url: '',
      }, {
        num: '6',
        content: '特殊考生证明资料',
        require: '符合加分（除截止到2021年12月31日年满25周岁）或免试照顾政策考生需上传相关证明图片',
        isUP: '未上传',
        conmp: '否',
        url: '',
      }, {
        num: '7',
        content: '报名信息查看图片',
        require: '9月份招考院官网提交报名信息查看的照片',
        isUP: '未上传',
        conmp: '否',
        url: '',
      }, {
        num: '8',
        content: '考试费已交纳图片',
        require: '高起专/专升本130元，高起本170元',
        isUP: '未上传',
        conmp: '否',
        url: '',
      }, {
        num: '9',
        content: '考试分数图片',
        require: '',
        isUP: '未上传',
        conmp: '否',
        url: '',
      }, {
        num: '10',
        content: '录取院校图片',
        require: '',
        isUP: '未上传',
        conmp: '否',
        url: '',
      }, {
        num: '11',
        content: '交纳学费图片',
        require: '',
        isUP: '未上传',
        conmp: '否',
        url: '',
      }, {
        num: '12',
        content: '学信网学籍注册备案表',
        require: '',
        isUP: '未上传',
        conmp: '否',
        url: '',
      }, {
        num: '13',
        content: '学信网学籍查询图片',
        require: '',
        isUP: '未上传',
        conmp: '否',
        url: '',
      }],
      baoming_id: '', //报名id
      showDialog: false,//显示弹窗
      dialogImageUrl: '',//弹窗显示的图片
    }
  },
  created() {
    if(this.baoming_id) {
      this.getUpload();
    }else {
      this.getUserInfo();
    }
  }
}
</script>

<style>

</style>